<div class="preloader">
    <div class="loader">
        <div class="sbl-half-circle-spin">
            <div></div>
        </div>
    </div>
</div>